import React from 'react';
import GridContainer from './components/structure_components/1_GridContainer';
import './components/css_files/1_base_style.css';
import './components/css_files/2_1_navigation.css';
import './components/css_files/2_2_menu_icon.css';
import './components/css_files/2_3_logo.css';
import './components/css_files/3_0_main_page.css';
import './components/css_files/3_1_hero.css';
import './components/css_files/3_2_benefit.css';
import './components/css_files/3_3_specification.css';
import './components/css_files/3_4_presentation.css';
import './components/css_files/4_footer.css';
import './components/css_files/5_back_to_top_link.css';
import './components/css_files/6_media_queries.css';
import './components/css_files/7_1_cookie_bar.css';
import './components/css_files/7_2_legal_texts.css';


function App() {
  return (
    <div className="App">
      <GridContainer />
    </div>
  );
}

export default App;
